<template>


	<div id='page'>
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso de trabajos OT ( OT {{ idcotizacionvehiculo }})</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
				v-bind:style="userimageurl"></a>
		</div>


		<div id='content1'>

			<div class="calendar round-small shadow-small">
				<div class="cal-header">
					<h5 class="cal-title center-text uppercase bolder bg-blue2-light color-red">{{ sucursal }}</h5>
				</div>
			</div>


			<div class="calendar">
				<div class="search-box search-color bg-green1-dark shadow-tiny round-huge bottom-0">
					<i class="fa fa-search"></i>
					<input id="Inputdatasearchfx" type="text" v-model="datasearch" @keyup="datasearchfx"
						placeholder="Agregar trabajo (descripción y/o area trabajo)" data-search>
				</div>
			</div>

			<div v-for="(t, index) in trabajosagregar" class="content">
				<div class="user-list-slider bottom-0">
					<h4 class="color-black-dark">{{ t.descripcionareatrabajo }}</h4>
					<div class="user-list-right">
						<h5 class="color-blue2-dark">{{ t.descripcion }}</h5>
						<form v-bind:id="'FormsubmitTrabajo'+t.codtipocaracteristica">
							<input id="fx" type="ot.savetrabajosagregar">
							<input v-bind:id="'mt$txtID_'+t.codtipocaracteristica"
								v-bind:name="'mt$txtID_'+t.codtipocaracteristica" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_I'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_I'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_REV'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_REV'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_REP'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_REP'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_DM'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_DM'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_C'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_C'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_P'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_P'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_SIM'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_SIM'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_PUL'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_PUL'" type="hidden" v-bind:value="''">
							<input v-bind:id="'chk_'+t.codtipocaracteristica+'_REA'"
								v-bind:name="'chk_'+t.codtipocaracteristica+'_REA'" type="hidden" v-bind:value="''">
						</form>

						<button v-if="t.instalar" @click="seltrabajo(t.codtipocaracteristica,'I','red2')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkI'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Instalar</span>
						</button>
						<button v-if="t.revisar" @click="seltrabajo(t.codtipocaracteristica,'REV','yellow2')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkREV'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Revisar</span>
						</button>
						<button v-if="t.simunizar" @click="seltrabajo(t.codtipocaracteristica,'SIM','green2')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkSIM'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Simunizar</span>
						</button>
						<button v-if="t.pulir" @click="seltrabajo(t.codtipocaracteristica,'PUL','mint')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkPUL'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Simunizar</span>
						</button>
						<button v-if="t.reparar" @click="seltrabajo(t.codtipocaracteristica,'REP','blue2')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkREP'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Reparar</span>
						</button>
						<button v-if="t.desmontar" @click="seltrabajo(t.codtipocaracteristica,'DM','magenta2')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkDM'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Desmontar</span>
						</button>
						<button v-if="t.cambiar" @click="seltrabajo(t.codtipocaracteristica,'C','pink1')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkC'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Cambiar</span>
						</button>
						<button v-if="t.pintar" @click="seltrabajo(t.codtipocaracteristica,'P','brown2')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkP'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Pintar</span>
						</button>
						<button v-if="t.realizar" @click="seltrabajo(t.codtipocaracteristica,'REA','dark1')"
							class="chip chip-small bg-gray1-dark">
							<i v-bind:id="'checkREA'+t.codtipocaracteristica" class="fa fa-times bg-gray1-dark"></i>
							<span class="color-black">Realizar</span>
						</button>

						<button v-bind:id="'button'+t.codtipocaracteristica"
							@click="agregarTrabajo(t.codtipocaracteristica,t.codtipoareatrabajo)"
							class="next-slide-user fa-1x bg-green1-dark none" style="top:-25px">Agregar</button>
					</div>
				</div>

				<div class="divider"></div>


			</div>
			<br>

			<div v-for="(t, index) in trabajosagregados" class="content">
				<h4>{{ t.descripcionareatrabajo }}</h4>
				<div class="user-list-slider bottom-0">
					<div class="user-list-right">
						<h5 class="color-pink2-dark">{{ t.descripcion }}</h5>
						<span v-if="t.instalar"><i class="fa fa-check color-red2-dark"></i> Instalar
							&nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.revisar"><i class="fa fa-check color-yellow2-dark"></i> Revisar
							&nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.suminizar"><i class="fa fa-check color-green2-dark"></i> Simunizar
							&nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.pulir"><i class="fa fa-check color-mint-dark"></i> Pulir &nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.reparar"><i class="fa fa-check color-blue2-dark"></i> Reparar
							&nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.desmontar"><i class="fa fa-check color-magenta2-dark"></i> Desmontar
							&nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.cambiar"><i class="fa fa-check color-pink1-dark"></i> Cambiar
							&nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.pintar"><i class="fa fa-check color-brown2-dark"></i> Pintar
							&nbsp;&nbsp;&nbsp;</span>
						<span v-if="t.realizar"><i class="fa fa-check color-dark1-dark"></i> Realizar
							&nbsp;&nbsp;&nbsp;</span>

						<a href="#" @click="eliminarTrabajo(t.coddetallecaracteristica)"
							class="next-slide-user fa-1x bg-red1-dark" style="top:40px">Eliminar</a>
					</div>
				</div>

				<div class="divider"></div>


			</div>

			<form onsubmit="event.preventDefault();" id="Formsubmitcliente">
				<div class="content">
					<div class="calendar">
						<fieldset>
							<span id="r_email" style="display:none"
								class="bg-red2-dark center-text uppercase color-white ultrabold">El e-mail es
								requerido</span>
							<span id="e_email" style="display:none"
								class="bg-red2-dark center-text uppercase color-white ultrabold">El e-mail debe tener
								formato correcto</span>
							<div class="form-field form-name" style="text-align:left">
								<label class="color-theme">Email contacto:<span>(requerido)</span></label>
								<input id="email" name="field_ST_EMAIL_CLIENTE" v-model="OT.email" maxlength="100"
									type="text" class="round-small">
							</div>

							<span id="r_fono1suf" name="r_fono1suf" style="display:none"
								class="bg-red2-dark center-text uppercase color-white ultrabold">Teléfono
								contacto(WhatsApp) requerido</span>
							<span id="i_fono1suf" name="i_fono1suf" style="display:none"
								class="bg-red2-dark center-text uppercase color-white ultrabold">Teléfono debe ser un nú
								mero</span>
							<div class="form-field form-name" style="text-align:left">
								<label class="color-theme">Teléfono contacto(WhatsApp):<span>(requerido)</span></label>
								<table cellpadding="0" cellspacing="0">
									<tr>
										<td><input ref="fono1pref" disabled class="round-small" value='569' maxlength=2
												size=2></td>
										<td>-</td>
										<td><input placeholder='Teléfono contacto' id="fono1suf" ref="fono1suf"
												@change="changefono1()" class="round-small" maxlength=8 size=10></td>
									</tr>
								</table>
								<input type="hidden" v-model="OT.fono1" name='field_ST_FONO1_CLIENTE'
									id='field_ST_FONO1_CLIENTE'>
							</div>

						</fieldset>
						<br>
					</div>
				</div>

			</form>

			<form onsubmit="event.preventDefault();" id="Formsubmit">

				<div class="content-boxed">
					<div class="content">

						<div class="calendar">
							<fieldset>
								<span id="i_valorestimado" style="display:none"
									class="bg-red2-dark center-text uppercase color-white ultrabold">El Valor estimado
									debe ser un número</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Valor estimado Orden de trabajo:</label>
									<input 
										id="valorestimado" 
										name="field_IN_VALORESTIMADOOT_COTIZACIONVEHICULO"
										v-model="OT.valorestimado" 
										type="number"
										min="0" 
										max="99999999" 
										step="1"
										@focus="onfocusnumericfield('valorestimado')"
										@blur="onblurnumericfield('valorestimado')"
										@focusout="onblurnumericfield('valorestimado')"
										class="round-small">
								</div>

							</fieldset>
							<br>
						</div>

						<h4 class="bolder">Descripción de trabajos</h4>

						<span ref="r_trabajos" style="display:none"
							class="bg-red2-dark center-text uppercase color-white ultrabold">Se requiere el ingreso de
							algún trabajo</span>

						<!-- <div v-if="!c.cols" v-for="(c, index) in caracteristicas"
							class="content-boxed shadow-large bg-mint-light">
							<div class="content bottom-0">
								<h3 class="bolder">{{ c.descripcion }}</h3>
								<p>

									<input type="hidden" v-bind:id="c.id" v-bind:name="c.name" value=''>
									<span v-if="c.requerido" v-bind:id="'r_mt_cbo_'+c.codtipocaracteristica"
										style="display:none"
										class="bg-red2-dark center-text uppercase color-white ultrabold">Dato
										requerido</span>
								</p>
								<div v-bind:id="'lista_'+c.id" v-if="c.eslista" class="row">
									<input type="hidden" v-bind:id="'mt_cbo_'+c.codtipocaracteristica"
										v-bind:name="'mt$cbo_'+c.codtipocaracteristica"
										v-bind:value='c.listaselectedvalue'>
									<span v-for="(l, index) in c.lista">
										<span v-if="c.listaselectedvalue">
											<button v-if="l.selected"
												v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index"
												@click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)"
												class="button button-s shadow-small button-circle bg-orange-dark">{{
												l.text }}</button>
											<button v-else
												v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index"
												@click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)"
												class="button button-s shadow-small button-circle bg-gray2-light">{{
												l.text }}</button>
										</span>
										<span v-else>
											<button v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index"
												@click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)"
												class="button button-s shadow-small button-circle bg-orange-light">{{
												l.text }}</button>
										</span>
									</span>

								</div>

							</div>
						</div> -->

					</div>
				</div>

				<div class="content-boxed">
					<div class="content">
						<div v-if="c.cols" v-for="(c, index) in caracteristicas"
							class="content-boxed shadow-large bg-mint-light">
							<div class="content bottom-0">
								<h3 class="bolder">{{ c.descripcion }}</h3>
								<p>
									<span>
										<input type=hidden v-bind:name="c.iddtype" v-bind:id="c.iddtype"
											v-bind:value="c.tipocampo">
										<textarea type=input class='form-control' v-bind:id="c.iddfield"
											v-bind:name="c.iddfield" v-bind:rows="7" v-bind:cols="c.cols"
											style="width:100%">{{ c.value.replace(/<br>/g,'\n') }}</textarea>
									</span>

									<input type="hidden" v-bind:id="c.id" v-bind:name="c.name" value=''>
									<span v-if="c.requerido" v-bind:id="'r_mt_cbo_'+c.codtipocaracteristica"
										style="display:none"
										class="bg-red2-dark center-text uppercase color-white ultrabold">Dato
										requerido</span>
								</p>
								<div v-bind:id="'lista_'+c.id" v-if="c.eslista" class="row">
									<input type="hidden" v-bind:id="'mt_cbo_'+c.codtipocaracteristica"
										v-bind:name="'mt$cbo_'+c.codtipocaracteristica"
										v-bind:value='c.listaselectedvalue'>
									<span v-for="(l, index) in c.lista">
										<span v-if="c.listaselectedvalue">
											<button v-if="l.selected"
												v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index"
												@click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)"
												class="button button-s shadow-small button-circle bg-orange-dark">{{
												l.text }}</button>
											<button v-else
												v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index"
												@click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)"
												class="button button-s shadow-small button-circle bg-gray2-light">{{
												l.text }}</button>
										</span>
										<span v-else>
											<button v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index"
												@click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)"
												class="button button-s shadow-small button-circle bg-orange-light">{{
												l.text }}</button>
										</span>
									</span>

								</div>

							</div>
						</div>

					</div>
				</div>

				<div class="content-boxed">
					<a href="#"
						class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton"
						@click="siguiente">Siguiente</a>
				</div>
			</form>

		</div>


		<br>
		<br>
		<br>
	</div>


</template>

<style scoped>
/* Customize the label (the container) */
.none {
  display: none;
}
.display {
  display:'';
}
</style>

<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";

export default {
    data() {
      return {
		params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO","entity":"8","classifications":"41"}',
		paramsFormulario:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO","entity":"8","classifications":"41"}',
		idcotizacionvehiculo: localStorage.getItem('idcotizacionvehiculo'),
		idagenda:localStorage.getItem('idagenda'),
		userimageurl:"background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")",  
		codsucursal:JSON.parse(localStorage.getItem('user')).codsucursal,
		sucursal:JSON.parse(localStorage.getItem('user')).sucursal,

		paramscliente:"",
		datasearch:"",
		trabajosagregar:[],
		trabajosagregados:[],
		caracteristicas:[],

		OT:{
			  marca:"",
			  modelo:"",
			  version:"",
			  agno:"",
			  placapatente:"",
			  vin:"",

			  kilometraje:0,
			  datatipoot:"",
			  datatipotrabajo:"",
			  fechaentrega:"",
			  horaentrega:"",
			  codcliente:0,
			  valorestimado:0
			  }

      }
    },

	created() {      
		let strSql;

	strSql="SELECT IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO kilometraje,"
			+"DT_FECHAENTREGAOT_COTIZACIONVEHICULO fechaentregaot,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,120) fechaentrega,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,108) horaentrega,"
			+"COT.IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO datatipoot,"
			+"COT.IN_COD_TIPOTRABAJO datatipotrabajo,"
			+"CLI.ST_NOMBRE_CLIENTE nombre,"
			+"CLI.ST_APEPAT_CLIENTE paterno,"
			+"CLI.ST_APEMAT_CLIENTE materno,"
			+"CLI.ST_FONO1_CLIENTE fono1,"
			+"'' fono1clientepref,'' fono1clientesuf,"
			+"CLI.ST_EMAIL_CLIENTE email,"
			+"CLI.IN_COD_CLIENTE codcliente,"
			+"'"+db.getServerHTTP()+"/taller/tlrShowOT2.aspx?id='+ST_IDEXTERNO_COTIZACIONVEHICULO+'_"+this.idFile+"' idexternopdf,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) version,"
			+"IN_AGNOFABRICACION_VEHICULO agno,ST_PLACAPATENTE_VEHICULO placapatente,ST_NVIN_VEHICULO vin,"
			+"IN_VALORESTIMADOOT_COTIZACIONVEHICULO valorestimado"			
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V,T_CLI_CLIENTE CLI"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.OT=result.data.data

			if(this.OT.fono1.length>3)
				{
				this.$refs.fono1pref.value="569";
				this.$refs.fono1suf.value=this.OT.fono1.substring(3);
				}
		}}); 

		this.gettrabajos()

		// db.getFx3("ot.getcaracteristicas",this.params).then(result => {
		// 	if (result.data.err!="")
		// 	{
		// 		console.log(result.data);
		// 		alert("Error: " + result.data.err);
		// 		console.log ("Error: " + result.data.err);
		// 	}
		// 	else
		// 	{
		// 	console.log(result)
		// 	this.caracteristicas=result.data.data
		// 	}
		// });

		db.getFx3("ot.getcaracteristicas", this.params).then(result => {

			let data = [];

			try {
				let raw = result.data;

				if (typeof raw === "string") {
				raw = raw
					.replace(/\t/g, " ")
					.replace(/\n/g, " ")
					.replace(/\r/g, " ");

				raw = JSON.parse(raw);
				}

				if (raw && Array.isArray(raw.data)) {
				data = raw.data;
				}

			} catch (e) {
				console.log("Error final parse:", e);
			}

			this.caracteristicas = data;
		});

	},


  methods: {
		onfocusnumericfield(objid){validate.onfocusnumericfield(document.getElementById(objid))},
		onblurnumericfield(objid){validate.onblurnumericfield(document.getElementById(objid))},

		changefono1(){this.OT.fono1=this.$refs.fono1pref.value+''+this.$refs.fono1suf.value;this.$forceUpdate();},

	  	seltrabajo(codtipocaracteristica,type,classbutton){			
			if(document.getElementById('chk_'+codtipocaracteristica+"_"+type).value==""){
				document.getElementById('chk_'+codtipocaracteristica+"_"+type).value="on"
				document.getElementById('check'+type+codtipocaracteristica).className="fa fa-check bg-"+classbutton+"-dark"

			}
			else{
				document.getElementById('chk_'+codtipocaracteristica+"_"+type).value=""
				document.getElementById('check'+type+codtipocaracteristica).className="fa fa-times bg-gray1-dark"
			}

			if (document.getElementById('chk_'+codtipocaracteristica+'_I').value ==""
				&& document.getElementById('chk_'+codtipocaracteristica+'_REV').value ==""			
				&& document.getElementById('chk_'+codtipocaracteristica+'_REP').value ==""			
				&& document.getElementById('chk_'+codtipocaracteristica+'_DM').value ==""			
				&& document.getElementById('chk_'+codtipocaracteristica+'_C').value ==""			
				&& document.getElementById('chk_'+codtipocaracteristica+'_P').value ==""			
				&& document.getElementById('chk_'+codtipocaracteristica+'_SIM').value ==""			
				&& document.getElementById('chk_'+codtipocaracteristica+'_PUL').value ==""			
				&& document.getElementById('chk_'+codtipocaracteristica+'_REA').value ==""			
				)
				document.getElementById("button"+codtipocaracteristica).className="next-slide-user fa-1x bg-green1-dark none"
			else
				document.getElementById("button"+codtipocaracteristica).className="next-slide-user fa-1x bg-green1-dark"

			//document.getElementById('button'+codtipopautatrabajo).className="next-slide-user fa-1x bg-green1-dark none"
	  	},

		agregarTrabajo(codtipocaracteristica,codtipoareatrabajo){
			let codusuario=JSON.parse(localStorage.getItem('user')).codusuario;

			document.getElementById("Inputdatasearchfx").value="" 

			var FormsubmitTrabajo=document.getElementById("FormsubmitTrabajo"+codtipocaracteristica);
			this.params='{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","codusuario":"'+codusuario+'","codtipoareatrabajo":"'+codtipoareatrabajo+'","fx":"ot.savetrabajosagregar"}';

			db.sendDataForm(FormsubmitTrabajo,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.trabajosagregar=[]
				this.gettrabajos()
			}});

		},

		eliminarTrabajo(coddetallecaracteristica){
			let strSql;
			
			strSql = "DELETE FROM T_CAR_DETALLECARACTERISTICA"
				+ " WHERE IN_COD_DETALLECARACTERISTICA=" + coddetallecaracteristica
				+ " AND IN_EDITARREGISTRO_DETALLECARACTERISTICA=1"

			db.ExecuteQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.gettrabajos()
			}}); 

		},

		seleccioncaracteristica(codcaracteristica,index,value)
			{
			document.getElementById("mt_cbo_"+codcaracteristica).value=value
			document.getElementById("mt_itemcbo_"+codcaracteristica+"_sel_"+index).className="button button-s shadow-small button-circle bg-orange-dark"

			var intLen=document.getElementById("lista_mt_txtID_"+codcaracteristica).children.length;

			var i;
			for (i=0;i<intLen;i++)
				if(i!=index)
					document.getElementById("mt_itemcbo_"+codcaracteristica+"_sel_"+i).className="button button-s shadow-small button-circle bg-gray2-light"
			
			return false;
			},

		siguiente()
	  	{
			var strErr=validate.check(Formsubmitcliente)
			
			if (strErr==""){
				validate.Cleannumericfield(Formsubmitcliente);
				this.paramscliente='{"valkey":"'+this.OT.codcliente+'","tablename":"T_CLI_CLIENTE"}';
				db.sendDataForm(Formsubmitcliente,this.paramscliente)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					strErr=validate.check(Formsubmit)
					if (strErr==""){
						validate.Cleannumericfield(Formsubmit);

						if(this.trabajosagregados.length>0)
							{
							db.sendDataForm(Formsubmit,this.paramsFormulario)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
								window.location="/Wizardot6showprint"
							}});				
							}
						}

				}});				
			}



		},

		gettrabajos(strFecha) {
			db.getFx("ot.gettrabajosagregados",'{"idcotizacionvehiculo":"'+this.idcotizacionvehiculo+'"}')   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log ( "Error trabajos: " + result.data.err);}else{
				this.trabajosagregados=result.data.data
				if (this.trabajosagregados.length==0)
					this.$refs.r_trabajos.style.display='';
				else
					this.$refs.r_trabajos.style.display='none';
					//document.getElementById('r_trabajos').style.display='';

				}});

		},

		datasearchfx()
		{
			if (this.datasearch.length >= 5) {
			db.getFx3("ot.gettrabajosagregar", 
				JSON.stringify({
					datasearch: this.datasearch,
					idcotizacionvehiculo: this.idcotizacionvehiculo,
					codsucursal: this.codsucursal
				})
			).then(result => {

				console.log("Respuesta completa:", result);

				if (!result || !result.data) {
					alert("Error: Respuesta vacía o mal formada");
					console.log("Error: Respuesta vacía o mal formada");
					return;
				}

				// Verificar si la respuesta tiene datos y si es un objeto o array
				if (result.data.err) {
					alert(result.data.err);
					console.log("Error recibido:", result.data.err);
				} else {
					// Comprobamos si result.data es un array o un objeto y lo ajustamos a un array
					if (Array.isArray(result.data)) {
						// Si result.data ya es un array, lo asignamos directamente
						this.trabajosagregar = result.data;
						console.log("Datos recibidos como array:", this.trabajosagregar);
					} else if (result.data.data && Array.isArray(result.data.data)) {
						// Si result.data tiene un campo 'data' que es un array, lo asignamos
						this.trabajosagregar = result.data.data;
						console.log("Datos recibidos desde result.data.data:", this.trabajosagregar);
					} else {
						// Si no tiene la estructura esperada, mostramos un error
						alert("Datos mal formados, no se pudo extraer el array");
						console.log("Error: Datos mal formados, no se pudo extraer el array");
					}
				}
				
			}).catch(error => {
				alert("Error en la petición");
				console.log("Error en la petición:", error);
			});
		}
		},
	
	}
}


/*
methods: {
		make_requests_handler() {
		this.message = 'Requests in progress'

		axios.all([
			this.request_1(), //or direct the axios request
			this.request_2()
		])
		.then(axios.spread((first_response, second_response) => {
			this.message = 'Request finished'
			this.first_request = 'The response of first request is' + first_response.data.message
			this.second_request = 'The response of second request is' + second_response.data.message
			}))
		},
		request_1() {
		this.first_request: 'first request began'
		return axios.get('you_URL_here')
		},
		request_2() {
		this.second_request: 'second request began'
		return axios.get('another_URL', { params: 'example' })
		},
	

      sendData() {
          var bodyFormData = new FormData();

          bodyFormData.set('userName', 'Fred');
          bodyFormData.set('userName2', 'Fred2');
          //bodyFormData.append('image', imageFile); 

          axios({ method: "POST", "url": "http://localhost:50130/http/test.aspx",data: bodyFormData,headers: {'Content-Type': 'multipart/form-data'}}).then(result => {
                    this.response = result.data;
                }, error => {
                    console.error(error);
                });


/*
this.$http.post("http://localhost:60742/api/test/2").then(result => {
      alert("resultdata");
          this.response = result.data;
        }, error => {
      alert("errorsend");
          console.error(error);
        });
      */
	 /*
      }
    }
  }
  */
</script>
